import { Order } from '@interfaces/OrderTypes';
import { formatToCurrency } from '@utils/formats';
import { computeBreakdownResidual, printedOrderTotal, RESIDUAL_LABEL } from '@utils/print/orderTotals';
import { PosPrintTableField } from '@plick/electron-pos-printer';

export const getOrderFooter = (pedido: Order): PosPrintTableField[][] => {
  const residual = computeBreakdownResidual(pedido, { includeShipping: true });
  return [
    [
      { type: 'text', value: 'Subtotal', style: { textAlign: 'right', padding: '2px', paddingTop: '5px' } },
      { type: 'text', value: formatToCurrency(pedido.subtotal || 0), style: { padding: '2px', paddingTop: '5px' } },
    ],
    pedido?.coupon_amount
      ? [
          { type: 'text', value: 'Descuento', style: { textAlign: 'right', padding: '2px' } },
          { type: 'text', value: `-${formatToCurrency(pedido.coupon_amount)}`, style: { padding: '2px' } },
        ]
      : [],
    pedido?.propina
      ? [
          { type: 'text', value: 'Propina', style: { textAlign: 'right', padding: '2px' } },
          { type: 'text', value: formatToCurrency(pedido.propina), style: { padding: '2px' } },
        ]
      : [],
    [
      { type: 'text', value: 'Costo de envío', style: { textAlign: 'right', padding: '2px' } },
      { type: 'text', value: formatToCurrency(pedido?.costo_envio || 0), style: { padding: '2px' } },
    ],
    // Línea residual: cuando el desglose NO suma el total que se imprime, la diferencia se dice
    // en vez de taparse. `includeShipping: true` porque esta ruta imprime SIEMPRE la línea de
    // envío (arriba, sin gate por método de entrega), a diferencia de webble y del PDF.
    residual !== 0
      ? [
          { type: 'text', value: RESIDUAL_LABEL, style: { textAlign: 'right', padding: '2px' } },
          { type: 'text', value: formatToCurrency(residual), style: { padding: '2px' } },
        ]
      : [],
    [
      {
        type: 'text',
        value: 'Total a pagar',
        style: { textAlign: 'right', fontWeight: '600', padding: '2px' },
      },
      {
        type: 'text',
        // El total que se imprime es `pedido.total` del servidor — lo que el cliente vio y lo
        // que realmente se cobró. Igual en las tres rutas.
        value: formatToCurrency(printedOrderTotal(pedido)),
        style: { fontWeight: '600', padding: '2px' },
      },
    ],
  ];
};
